<!-- eslint-disable -->
<template>
	<div class="d-flex flex-column text-12 text-gotham-medium m-width text-14" :class="orientation == 'desktop'?' w-50 m-auto':''">
		<PaxelLoader :loading="loadingIcon" style="
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate3d(-50%, -50%, 0);">
		</PaxelLoader>

		<MobileOrderStatusToStore v-if="!loadingIcon && status == statusImported" :order="order" :status="status" :boxLocationDetail="boxLocationDetail" />
		<MobileOrderStatusOverdue v-else-if="!loadingIcon && status == statusInStore && pageStatus == 'overdue'" :order="order" :status="status" :boxLocationDetail="boxLocationDetail" />
		<MobileOrderStatusStop v-else-if="!loadingIcon && status == statusInStore && pageStatus == 'stop'" :order="order" :status="status" :boxLocationDetail="boxLocationDetail" />
		<MobileOrderStatusInStore v-else-if="!loadingIcon && status == statusInStore" :order="order" :status="status" :boxLocationDetail="boxLocationDetail" @refreshOrderStatus="getOrderStatus" />
		<!-- for status other with no action, CANCEL, TAKEN_BY_SYSTEM, CUSTOMER_TAKEN-->
		<MobileOrderStatusOther v-else-if="!loadingIcon && order != null" :order="order" :status="status" :boxLocationDetail="boxLocationDetail" />

	</div>
</template>
<script>
/* eslint-disable */
import i18n from '@/plugins/i18n';
import PaxelLoader from '@/components/PaxelLoader.vue';
import MobileOrderStatusToStore from '@/views/mobile/order/status/ToStore.vue';
import LocalStorage from '@/services/localstorage';
import { isMobile } from 'mobile-device-detect';
import MobileOrderStatusInStore from '@/views/mobile/order/status/InStore.vue';
import MobileOrderStatusOther from '@/views/mobile/order/status/Other.vue';
import MobileOrderStatusOverdue from '@/views/mobile/order/status/Overdue.vue';
import MobileOrderStatusStop from '@/views/mobile/order/status/Stop.vue';


export default {
	components: { PaxelLoader,MobileOrderStatusToStore, MobileOrderStatusInStore,MobileOrderStatusOverdue, MobileOrderStatusStop,MobileOrderStatusOther },
  data() {
    return {
			loadingIcon: true,
			loadingApi: false,
			status: '',
			prev_status: '', // previous status before changes
			order:null,
			boxLocationDetail:null,
			orientation:'desktop',
			checkOrderStatusInterval:5,
			counterCheck:null,
			errorAlertShowed:false,
			statusInStore : "IN_STORE",
			statusImported : "IMPORTED",
			statusCustomerTaken : "CUSTOMER_TAKEN"
    };
  },
	computed: {
		pageStatus() {
			return this.$route.query.status;	
		},
	},
	unmounted(){
	},
	watch: {
    $route(val) {
      if (!val.query.preview) {
        const viewer = document.getElementsByClassName('viewer-canvas')?.[0];
        if (viewer) {
          viewer.click();
        }
      }
    },
  },
	mounted(){
		if(!this.counterCheck){
			this.counterCheck = setInterval(() => {
				this.getOrderStatus(true);
			}, this.checkOrderStatusInterval * 1000);
		}
	},
	beforeDestroy() {
    if (this.counterCheck) {
      clearInterval(this.counterCheck);
    }
  },
  async beforeMount() {
		clearInterval(this.counterCheck);
		let settings = this.$store.getters.getSettings;
		if(!settings){
			this.$store.dispatch("getSettings")
		}
		if (isMobile){
			this.orientation = 'mobile'
		}
		if(this.$route.query.token){
			LocalStorage.setUserToken(this.$route.query.token);
		}
		//this function is for replacement computed on vue, because value call on vanila js not vue
		window.addEventListener('yellowai-key-localstorage-changed', (event) => {
			this.yellowai = event.detail.storage;
		});
		this.yellowai = localStorage.getItem('yellowai')
			
		await this.validateUser()
    
  },
  methods: {
    redirectToPaxelbox() {
      this.$router.push({ path: '/' });
    },
		validateUser() {
			let token = this.$route.query.token?this.$route.query.token:LocalStorage.getUserToken()
			let data_payload = {
				"token": token
			}
			if (token){
				this.$store.dispatch("validateUser", data_payload)
				.then(() => {
					this.getOrderStatus()
				})
				.catch((error) => {
					const message = error.response.data.message || i18n.t('something_wrong');
					this.$swal({
						icon: 'error',
						title: 'Oops...',
						text: message,
					});
				});
			}
		},
		getOrderStatus(is_interval = false){
			const paramOrderId = this.$route.query.orderid;
			if (paramOrderId !== undefined) {
				if(this.loadingApi === false){
					this.loadingApi = true;
					if(!is_interval){
						this.loadingIcon = true;
					}
						this.$store.dispatch('getOrderStatus', paramOrderId)
						.then((res) => {
							this.loadingApi = false
							this.order = res.data
							this.status = this.order.status
							if(this.status == "CANCEL"){
								//remove interval check status
								clearInterval(this.counterCheck)
								this.counterCheck = null
							}
							this.$store.dispatch('setOrderStatus', this.status)
							this.checkQrIsStore() // trigger function check qr by status changes
							this.loadingIcon = false;
							if(!is_interval){
								this.getBoxStatus(this.order.mouth.box.id, is_interval)
							}

							if(this.status == this.statusCustomerTaken && this.$route.query.status == 'stop' && this.$route.query.act == 'stop_count'){
								this.$router.push('order-status/action?act=stop_success');
							}
						})
						.catch((error) => {
							clearInterval(this.counterCheck)
							this.loadingApi = false
							const message = error.response.data.message || i18n.t('something_wrong');
							this.$swal({
								icon: 'error',
								title: 'Oops...',
								text: message,
							});
						});
				}
			}
		},
		getBoxStatus(box_id, is_interval = false){
			if (box_id !== undefined) {
				if(!is_interval){
					this.loadingIcon = true;
				}
				this.$store.dispatch('getBoxStatus', box_id)
				.then((res) => {
					this.boxLocationDetail = res.data
					this.loadingIcon = false;
				})
				.catch((error) => {
					const message = error.response.data.message || i18n.t('something_wrong');
					this.$swal({
						icon: 'error',
						title: 'Oops...',
						text: message,
					});
				});
					
			} else {
				this.loadingIcon = false;
				this.redirectToPaxelbox();
			}
		},
		checkQrIsStore(){
			/* function to check is qr to in store is already scaned or not, because we cant get the trigger from scan process, so check by status changes */
			if(this.status == this.statusInStore && this.prev_status == this.statusImported){
				//when status change valid from import to store (mean user success open the door), send log event to netcore
				this.sendCustomEventStored()
				this.prev_status = this.status
			}else if(this.status == this.statusCustomerTaken && this.prev_status == this.statusInStore ) {
				//when status change valid from in store to Customer taken (mean user success stop the rent), send log event to netcore
				this.sendCustomEventStopRent()
				this.prev_status = this.status
			}
			else if(this.prev_status != this.status){
				//when status is change, record as previous status
				this.prev_status = this.status
			}
		},
		sendCustomEventStored(){
      if(this.$store.getters.getOrderDetail){
				let rentalDetail = this.$store.getters.getOrderDetail
				let startDate = this.epochToDateTimeLocalFormat(rentalDetail.createTime,true)
				let scanDate = this.epochToDateTimeLocalFormat(Date.now(),true)
        let netcorePayload = this.generalEventPayloadData();
				netcorePayload.Start_Date_Rent = startDate.date
				netcorePayload.Start_Time_Rent = startDate.time
				netcorePayload.Scan_Date_Rent = scanDate.date
				netcorePayload.Scan_Time_Rent = scanDate.time
				netcorePayload.Payment_Method = rentalDetail.paymentMethod
				this.recordEvent('store_package_paxelbox', netcorePayload) 
      }
		},
		sendCustomEventStopRent(){
      if(this.$store.getters.getOrderDetail){
				let rentalDetail = this.$store.getters.getOrderDetail
				let startDate = this.epochToDateTimeLocalFormat(rentalDetail.createTime,true)
				let scanDate = this.epochToDateTimeLocalFormat(Date.now(),true)
        let netcorePayload = this.generalEventPayloadData();
				netcorePayload.Start_Date_Rent = startDate.date
				netcorePayload.Start_Time_Rent = startDate.time
				netcorePayload.Scan_Date_Rent = scanDate.date
				netcorePayload.Scan_Time_Rent = scanDate.time
				netcorePayload.Payment_Method = rentalDetail.paymentMethod   
				this.recordEvent('Success_Stop_Rent_PaxelBox', netcorePayload) 
      }
		}
  },
};

</script>